@if (showMittanbud) {
  <ng-container *featureFlags="'show-mittanbud-banner'">
    <img [ngSrc]="'assets/img/mittanbud/mitanbud-image-cropped.webp'" height="500" width="800" class="absolute opacity-0 h-[45vh] object-contain" />

    @switch (view) {
      @case (mittanbudEnum.SMALL_VIEW) {
        <div
          (click)="open(MittanbudType.ON_SCHEDULER)"
          class="relative w-full bg-ivory pt-[12px] pb-2 px-2 my-2 rounded-[5px] cursor-pointer">
          <h3 class="text-12 text-indigo-blue font-magnet-bold !leading-[16px]">{{ mittanbudLabel | translate }}</h3>
          <p class="text-12 text-b2-dark-brick w-[170px] indent-0.5 !leading-[16px]">
            {{ mainSubtext | translate }}
          </p>

          <button
            (click)="cancelBanner($event)"
            class="icon-Close_round_ico absolute right-[10px] top-[10px] text-[9px] text-black-light"></button>
        </div>
      }
      @case (mittanbudEnum.FULL_VIEW) {
        <div class="relative w-full bg-ivory flex justify-between items-center !h-[54px] pt-[12px] p-2 mb-2 rounded-[5px]">
          <div class="flex gap-2 items-center">
            <img src="./assets/iconmoon-icons/Mitt-anbud_ico.svg" class="h-[28px] w-[33px]" />
            <div class="flex flex-col">
              <h3 class="text-12 text-b2-dark-brick font-magnet-bold !leading-[20px]">{{ winMoreJobs | translate }}</h3>
              <p class="text-12 text-b2-dark-brick !leading-[16px]">
                {{ mainText | translate }}
              </p>
            </div>
          </div>

          <div
            class="p-1 !text-b2-dark-brick uppercase !text-12 font-[500] bg-white rounded-[4px] border-[1px] border-gray-border cursor-pointer !mr-3"
            (click)="open(MittanbudType.ON_PROJECT)">
            <span class="icon-ExternalLink_ico mr-[4px]"></span>
            {{ claimOffer | translate }}
          </div>

          <button
            (click)="cancelBanner()"
            class="icon-Close_round_ico absolute right-[10px] top-[10px] text-[9px] text-black-light"></button>
        </div>
      }
    }
  </ng-container>
}
